// import React from "react";
// import "./Why_Motherhood.css";

// function Why_Motherhood() {
//   return (
//     <>
//       <section className="Why_Motherhood">
//         <div className="container-fluid">
//           <h4 className="heading_text">Why Motherhood</h4>

//           <div className="row align-items-center justify-content-center">
//             <div className="col-md-3">
//               <div className="content_holder">
//                 <div className="img_holder">
//                   <img
//                     src="/assets/images/home/Why_Motherhood/Grows_With_You.webp"
//                     alt="Grows_With_You"
//                     className="Why_Motherhood_img"
//                   />
//                 </div>
//                 <p>Grows With You</p>
//               </div>
//             </div>

//             <div className="col-md-3">
//               <div className="content_holder">
//                 <div className="img_holder">
//                   <img
//                     src="/assets/images/home/Why_Motherhood/Buttery_Soft.webp"
//                     alt="Buttery_Soft"
//                     className="Why_Motherhood_img"
//                   />
//                 </div>
//                 <p>Buttery Soft</p>
//               </div>
//             </div>

//             <div className="col-md-3">
//               <div className="content_holder">
//                 <div className="img_holder">
//                   <img
//                     src="/assets/images/home/Why_Motherhood/Machine_Washable.webp"
//                     alt="Machine_Washable"
//                     className="Why_Motherhood_img"
//                   />
//                 </div>
//                 <p>Machine-Washable</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }

// export default Why_Motherhood;

import React from "react";
import "./Why_Motherhood.css";

const features = [
  {
    img: "/assets/images/home/Why_Motherhood/Grows_With_You.webp",
    title: "Pregnancy to Postpartum",
  },
  {
    img: "/assets/images/home/Why_Motherhood/img5.png",
    title: "Easy & Discreet Feeding",
  },
  {
    img: "/assets/images/home/Why_Motherhood/Buttery_Soft.webp",
    title: "Buttery Soft",
  },
  {
    img: "/assets/images/home/Why_Motherhood/img2.png",
    title: "Designed by a Mother",
  },
  {
    img: "/assets/images/home/Why_Motherhood/Machine_Washable.webp",
    title: "Machine Washable",
  },
];

function Why_Motherhood() {
  return (
    <section className="Why_Motherhood">
      <div className="container">
        <div className="section_heading">
          <span>WHY CHOOSE US</span>
       
          <p>
            Designed with comfort, softness, and practicality to support every
            stage of your motherhood journey.
          </p>
        </div>

        <div className="row justify-content-center g-4">
          {features.map((item, index) => (
            <div className="col-lg-2 col-md-4 col-6" key={index}>
              <div className="content_holder">
                <div className="img_holder">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="Why_Motherhood_img"
                  />
                </div>
                <h5>{item.title}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Why_Motherhood;